import { useEffect, useState } from "react";

interface useApiServiceOptions<T> {
  serviceCall: () => Promise<T>;
  dependencies: any[];
}

const useApiService = <T>({
  serviceCall,
  dependencies,
}: useApiServiceOptions<T>) => {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setError(null);

    const fetchData = async () => {
      try {
        const data = await serviceCall();
        if (isMounted) setData(data);
      } catch (err: any) {
        if (isMounted) setError(err.response.data.message);
        console.error(err);
      } finally {
        if (isMounted) setLoading(false);
      }
      window.scrollTo(0, 0);
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, dependencies);

  return { data, loading, error };
};

export default useApiService;
